<template>
  <el-dialog
    :title="`${isEdit ? '编辑' : '新增'}职位`"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :show-close="false"
    :close-on-click-modal="false"
    width="50%"
    @close="onBeforeClose"
    @opened="opened"
  >
    <el-form ref="form" :model="form" :rules="rules" v-loading="loading">
      <el-form-item label="职位名称" prop="zhiwei_name">
        <el-input v-model="form.zhiwei_name" maxlength="16" placeholder="请输入职位名称"></el-input>
      </el-form-item>
      <el-form-item label="部门" prop="department">
        <department-cascade v-model="form.department" placeholder="请选择部门"></department-cascade>
      </el-form-item>
      <el-form-item label="级别" prop="zhiwei_jibie">
        <level-cascade v-model="form.zhiwei_jibie"></level-cascade>
      </el-form-item>
      <el-form-item label="负责人" prop="zhiwei_responsor">
        <person-picker v-model="form.zhiwei_responsor" placeholder="请选择负责人"></person-picker>
      </el-form-item>
      <el-form-item label="数量" prop="zhiwei_number">
        <el-input-number v-model.number="form.zhiwei_number" :min="1" :max="99"></el-input-number>
      </el-form-item>
      <el-form-item label="岗位标签" prop="tag" v-if="!isEdit">
        <el-radio-group v-model="form.tag">
          <el-radio-button label="上海"></el-radio-button>
          <el-radio-button label="北京"></el-radio-button>
          <el-radio-button label="广州"></el-radio-button>
          <el-radio-button label="深圳"></el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="岗位描述" prop="zhiwei_jd">
        <el-input type="textarea" :rows="6" v-model="form.zhiwei_jd" placeholder="请输入岗位描述"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="submit">确 定</el-button>
      <el-button @click="$emit('input', null)">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import DepartmentCascade from '@/components/service/department-cascade'
import LevelCascade from '@/components/service/level-cascade'
import PersonPicker from '@/components/service/person-picker'

export default {
  props: {
    value: {
      type: Object
    }
  },
  components: { DepartmentCascade, LevelCascade, PersonPicker },
  data () {
    return {
      isEdit: false,
      loading: false,
      visible: false,
      form: {
        department: [],
        zhiwei_name: '',
        zhiwei_jibie: '',
        zhiwei_responsor: [],
        zhiwei_number: 1,
        zhiwei_jd: '',
        tag: '',
        jiagou_first: '',
        jiagou_second: '',
        jiagou_third: '',
        jiagou_forth: ''
      },
      rules: {
        department: { required: true, message: '请选择部门' },
        zhiwei_name: { required: true, message: '请输入职位名称' },
        zhiwei_jibie: { required: true, message: '请选择级别', trigger: 'change' },
        zhiwei_number: { required: true, message: '请输入数量' },
        zhiwei_responsor: { required: true, message: '请选择负责人', trigger: 'change' },
        zhiwei_jd: { required: true, message: '请输入岗位描述' },
        tag: { required: true, message: '请选择岗位标签', trigger: 'change' }
      }
    }
  },
  watch: {
    value (val) {
      this.visible = !!val
      this.isEdit = val && val.zhiwei_id
      this.isEdit && (this.loading = true)
    }
  },
  methods: {
    opened () {
      if (this.isEdit) {
        const form = JSON.parse(JSON.stringify(this.value))
        form.zhiwei_responsor = form.zhiwei_responsor.split(',')
        form.zhiwei_jd = form.zhiwei_jd.replace(/\\n/g, '\n')
        form.department = [ form.jiagou_first, form.jiagou_second, form.jiagou_third, form.jiagou_forth ].filter(x => +x > -1)
        this.form = form
        this.loading = false
      }
    },
    onBeforeClose () {
      this.$refs.form.resetFields()
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          let params = JSON.parse(JSON.stringify(this.form))
          params.zhiwei_responsor = params.zhiwei_responsor.join(',')
          params.jiagou_first = this.form.department[ 0 ]
          params.jiagou_second = this.form.department[ 1 ] || '-1'
          params.jiagou_third = this.form.department[ 2 ] || '-1'
          params.jiagou_forth = this.form.department[ 3 ] || '-1'
          delete params.department
          this.$http.post(`/zhaopin/zhiwei/${this.isEdit ? 'change' : 'add'}zhiwei2`, params).then(res => {
            if (res.successful) {
              this.$emit('input', null)
              this.$parent.$refs.table.reload()
            }
            this.loading = false
          })
        }
      })
    }
  }
}
</script>
